<ds-modal [modal]="modal" [title]="'add_workspace' | translate" [maxWidthPercentage]="80" (modalClosed)="onCancel()">
  <div class="modal-content-wrapper">
    <app-create-tenant-workspace-selector
      [modalMode]="true"
      [tenantId]="tenantId"
      (workspaceCreated)="onWorkspaceAdded($event)"
      (bulkCreated)="onBulkCreated()"
      (cancelled)="onCancel()"
    >
    </app-create-tenant-workspace-selector>
  </div>
</ds-modal>
